import {
  TypePlanSectionWithoutUnresolvableLinksResponse,
  TypePlanSectionDetailWithoutUnresolvableLinksResponse,
} from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import PlanSection from './PlanSection'

const mapDetailsSection = (props) => {
  const mapDetails = (details) => {
    return details.map((detail) => ({
      ...detail.fields,
    }))
  }
  return props.fields.detailsSection.map((section, idx) => ({
    ...section.fields,
    sectionDetails: mapDetails(section.fields.sectionDetails),
  }))
}

const ContentfulPlanSection = withContentful<TypePlanSectionWithoutUnresolvableLinksResponse['fields']>(PlanSection, {
  detailsSection: mapDetailsSection,
  extraDetailsSection: (props) => {
    const extraDetailsInSection = props.fields.extraDetailsSection
    const extraDetailsInSectionData: TypePlanSectionDetailWithoutUnresolvableLinksResponse['fields'][] =
      extraDetailsInSection?.map((section: TypePlanSectionDetailWithoutUnresolvableLinksResponse) => {
        return section.fields
      })
    return extraDetailsInSectionData
  },
})

export default ContentfulPlanSection
